import { useCallback, useContext } from "react";
import { StoreContext } from "../state/store";

export function useModal(name) {
  const { state, dispatch } = useContext(StoreContext);
  const isOpen = Boolean(state.ui.modals[name]);

  const open = useCallback(() => {
    dispatch({ type: "OPEN_MODAL", payload: name });
  }, [dispatch, name]);

  const close = useCallback(() => {
    dispatch({ type: "CLOSE_MODAL", payload: name });
  }, [dispatch, name]);

  const toggle = useCallback(() => {
    dispatch({ type: isOpen ? "CLOSE_MODAL" : "OPEN_MODAL", payload: name });
  }, [dispatch, isOpen, name]);

  return { isOpen, open, close, toggle };
}
